import Cookie from 'js-cookie';
import ComponentEvents from '@utils/component-events';

const setup = () => {
  if (Cookie.get('benable-country-code') !== undefined) {
    const countryCode = Cookie.get('benable-country-code');
    window.visitorCountry = countryCode;
    ComponentEvents.trigger('updated-visitor-country', window.visitorCountry);
    return;
  }

  let totalIntervals = 0;

  let interval = setInterval(() => {
    if (typeof geoip2 !== 'undefined') {
      clearInterval(interval);

      geoip2.country((resp) => {
        if (resp && resp['country'] && resp['country']['iso_code']) {
          const countryCode = resp['country']['iso_code'];
          Cookie.set('benable-country-code', countryCode, { expires: 7 });
          window.visitorCountry = countryCode;
          ComponentEvents.trigger('updated-visitor-country', window.visitorCountry);
        }
      });
    }

    totalIntervals++;

    if (totalIntervals > 10) {
      clearInterval(interval);
    }
  }, 500);
};

export default {
  setup,
};
